import Pbp from 'components/general/Pbp'
import Referees from 'components/general/Referees'
import { Warnings, ActionTag } from './FenCommon'

// Overwrites Ppb default component in order to show actions as is defined in FEN discipline
const FenRenderSide = ({ action, homeAway, home }) => {
  const hasAction = action?.pbpa_Action !== undefined && action?.pbpa_ScoreH === undefined
  const hasActionAndScore = action?.pbpa_Action !== undefined && action?.pbpa_ScoreH !== undefined
  const className = action?.pbpa_Action === 'YC' || action?.pbpa_Action === 'P-y' ? 'text-warning' : action?.pbpa_Action === 'RC' || action?.pbpa_Action === 'P-r' ? 'text-danger' : ''
  let out = '';
  if (hasAction) {
    out = <span>{homeAway?.participant?.code === home?.participant?.code ? <ActionTag className={className} action={action?.pbpa_Action} /> : ''}</span>
  } else if (hasActionAndScore) {
    out = <><span>{homeAway?.participant?.code === home?.participant?.code ? action?.pbpa_ScoreH : action?.pbpa_ScoreA}</span> <span>{homeAway?.participant?.code === home?.participant?.code ? <ActionTag className={className} action={action?.pbpa_Action} /> : ''}</span></>
  } else {
    out = <span>{homeAway?.participant?.code === home?.participant?.code ? action?.pbpa_ScoreH : action?.pbpa_ScoreA}</span>
  }
  return (
    <div className="box">
      {out}
    </div>
  )
}

// Overwrites Ppb default component in order to show actions as is defined in FEN discipline
const FenRenderCenter = ({ action }) => {
  return (
    <div>{action?.pbpa_When}</div>
  )
}

function FenIndividual({ data, periodsOrder }) {

  const configPpb = {
    headerRender: () => { },             // A way to disable rendering of header
    sideRender: FenRenderSide,          // Overwrites default component
    centerRender: FenRenderCenter,      // Overwrites default component
    periodsOrder: periodsOrder,          // Takes periods order from OG2024.json TODO: take sorting from dt_codes 
    layout: "points_one_line",           // Usually when points, score etc is not in the center but in both sides
    reverseSorting: true                 // Shows latest action first
  }

  return (
    <div className="fen-pbp-main">
      <Pbp data={data} config={configPpb} />
      <Warnings data={data} />
      <Referees data={data?.results?.officials} config={{ header: 'Referees', source: 'official' }} />
    </div>
  );
}

export default FenIndividual;